import { render, staticRenderFns } from "./TaskContent.vue?vue&type=template&id=5d3ada20&scoped=true&"
import script from "./TaskContent.vue?vue&type=script&lang=js&"
export * from "./TaskContent.vue?vue&type=script&lang=js&"
import style0 from "./TaskContent.vue?vue&type=style&index=0&id=5d3ada20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ada20",
  null
  
)

export default component.exports